import { render, staticRenderFns } from "./journey-list.vue?vue&type=template&id=3970e8f8&scoped=true&"
import script from "./journey-list.vue?vue&type=script&lang=js&"
export * from "./journey-list.vue?vue&type=script&lang=js&"
import style0 from "./journey-list.vue?vue&type=style&index=0&id=3970e8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970e8f8",
  null
  
)

export default component.exports